import {h, Fragment} from "preact"
import { useFacets, useSelectedFiltersCount, useAppStateSelector, pick} from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import SelectedFilters from "./SelectedFilters"
import Icon from "./elements/Icon"
import { useState } from "preact/hooks"
import CollectionSearchLogic from "./CollectionSearch";

export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ${className}`}
            for={toggleButtonId}
        >
            <Icon name="close" />
        </label>
    )
}

function OpenSearchBar({ selectedFiltersCount, sidebarOpen, setSidebarOpen }) {
    return (
        <label
            for={toggleButtonId}
            className="ns-filters ns-d-none ns-d-md-inline-flex ns-text-align-center ns-align-items-center toggle-btn utility-bar__item"
            onClick={() => setSidebarOpen(!sidebarOpen)}
        >
            <span class="button-icon">
            <svg viewBox="0 0 19 21" fill="currentColor"><g transform="translate(0,0.472222)"><path d="M14.3977778,14.0103889 L19,19.0422222 L17.8135556,20.0555556 L13.224,15.0385 C11.8019062,16.0671405 10.0908414,16.619514 8.33572222,16.6165556 C3.73244444,16.6165556 0,12.8967778 0,8.30722222 C0,3.71766667 3.73244444,0 8.33572222,0 C12.939,0 16.6714444,3.71977778 16.6714444,8.30722222 C16.6739657,10.4296993 15.859848,12.4717967 14.3977778,14.0103889 Z M8.33572222,15.0585556 C12.0766111,15.0585556 15.1081667,12.0365 15.1081667,8.30827778 C15.1081667,4.58005556 12.0766111,1.558 8.33572222,1.558 C4.59483333,1.558 1.56327778,4.58005556 1.56327778,8.30827778 C1.56327778,12.0365 4.59483333,15.0585556 8.33572222,15.0585556 Z"></path></g></svg>
            </span>
            <span>Search</span>
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-ml-1">
                    ({selectedFiltersCount})
                </span>
            )}
        </label>
    )
}

function OpenSidebar({ selectedFiltersCount, sidebarOpen, setSidebarOpen }) {
    return (
        <label
            for={toggleButtonId}
            className="ns-filters ns-d-none ns-d-md-inline-flex ns-text-align-center ns-align-items-center toggle-btn utility-bar__item"
            onClick={() => setSidebarOpen(!sidebarOpen)}
        >
            <span class="button-icon">
                <svg width="23" height="19" viewBox="0 0 20 20" stroke-width="1.25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="1" y1="6" x2="19" y2="6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
                    <line x1="1" y1="14" x2="19" y2="14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
                    <circle cx="7" cy="6" r="3" fill="none" stroke="currentColor"></circle>
                    <circle cx="13" cy="14" r="3" fill="none" stroke="currentColor"></circle>
                </svg>
            </span>
            <span>Filter</span>
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-ml-1">
                    ({selectedFiltersCount})
                </span>
            )}
        </label>
    )
}

export default function SideBar() {
    const { response } = useAppStateSelector(state => pick(state, "response"));
    const categoryPath = response.products?.categoryPath || null;
    const { loading, facets } = useFacets()
    const [ sidebarOpen, setSidebarOpen ] = useState(true)
    const selectedFiltersCount = useSelectedFiltersCount()

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={toggleButtonId}
            />
            <div class="ns-sidebar-wrapper ns-d-none ns-d-md-block ns-h-100">
                <div className="collection-search main-search ns-sidebar-content desktop-only">
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline">
                        <div class="filters__heading ns-d-block ns-d-md-none">
                            <h4 class="filters__heading-text">Search</h4>
                        </div>
                        <OpenSearchBar 
                            setSidebarOpen={setSidebarOpen} 
                            sidebarOpen={sidebarOpen} 
                            selectedFiltersCount={selectedFiltersCount} 
                        />
                        <ToggleSidebarButton />
                    </div>
                    {categoryPath && (<CollectionSearchLogic categoryPath={categoryPath} />)}
                </div>
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline">
                        <div class="filters__heading ns-d-block ns-d-md-none">
                            <h4 class="filters__heading-text">Filter</h4>
                        </div>
                        <OpenSidebar 
                            setSidebarOpen={setSidebarOpen} 
                            sidebarOpen={sidebarOpen} 
                            selectedFiltersCount={selectedFiltersCount} 
                        />
                        <ToggleSidebarButton />
                    </div>
                    <SelectedFilters />
                    <div class={`ns-sidebar-menu ${sidebarOpen ? '' : 'ns-d-md-none'}`}>
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    ) : (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={toggleButtonId}
            />
            <div class="ns-sidebar-wrapper ns-d-none ns-d-md-block ns-h-100">
                <div className="collection-search main-search ns-sidebar-content desktop-only">
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline">
                        <div class="filters__heading ns-d-block ns-d-md-none">
                            <h4 class="filters__heading-text">Search</h4>
                        </div>
                        <OpenSearchBar 
                            setSidebarOpen={setSidebarOpen} 
                            sidebarOpen={sidebarOpen} 
                            selectedFiltersCount={selectedFiltersCount} 
                        />
                        <ToggleSidebarButton />
                    </div>
                    {categoryPath && (<CollectionSearchLogic categoryPath={categoryPath} />)}
                </div>
            </div>
        </>
    )
}
